<app-header></app-header>
<div class="container-fluid">
    <div class="row main-card-style">
      <mat-tab-group mat-align-tabs="start">
        <mat-tab label="Client Setup"><app-client-management></app-client-management></mat-tab>
        <mat-tab label="Project Setup"><app-project-management></app-project-management></mat-tab>
      </mat-tab-group>
    </div>
  </div>
<app-footer></app-footer>